import { render, staticRenderFns } from "./InterCommDiscFactors.vue?vue&type=template&id=21e8de17&"
import script from "./InterCommDiscFactors.vue?vue&type=script&lang=js&"
export * from "./InterCommDiscFactors.vue?vue&type=script&lang=js&"
import style0 from "./InterCommDiscFactors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InterCommDiscFactors.vue"
export default component.exports